<template>
    <v-dialog
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event)"
        width="800px"
    >
        <v-card>
            <v-card-title class="pa-4">
                <span class="text-typography1 text-display-small">
                    Share via link
                </span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-text-field
                        :model-value="fullurl()"
                        @focus="clickCopy($event)"
                        class="share-input"
                        label="URL"
                        :hint="message"
                        persistent-hint
                        variant="underlined"
                        readonly
                        color="typography2"
                        style="--v-input-control-height: 36px"
                    >
                        <template v-slot:append-inner>
                            <v-btn
                                id="calc-btn"
                                @click.stop="copyToClipboard(fullurl())"
                                icon="mdi-content-copy"
                                variant="text"
                                :height="36"
                                :width="36"
                            >
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    variant="text"
                    class="text-title-small"
                    @click="emit('update:modelValue', false)"
                >
                    CLOSE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps(['record', 'modelValue'])
const emit = defineEmits(['update:modelValue'])

const message = ref('')

async function clickCopy($event) {
    $event.target.select()
    await copyToClipboard(fullurl())
}

function fullurl() {
    if (props.record.calc.persistentCalcID) {
        const calc = props.record.calc
        return `${window.location.origin}/persistentCalcs/${
            calc.persistentCalcID
        }/${calc.major}/${calc.minor}/${calc.patch}?${getParams()}`
    } else {
        return `${window.location.origin}/calcs/${
            props.record.calcId
        }?${getParams()}`
    }
}

function getParams() {
    let string = ''
    for (let param in props.record.body) {
        let val = props.record.body[param]
        if (Array.isArray(val) || val === Object(val)) val = JSON.stringify(val)
        let valUrl = encodeURIComponent(val)
        string += `${param}=${valUrl}&`
    }
    return string.substring(0, string.length - 1)
}

async function copyToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text)
        return
    }
    await navigator.clipboard.writeText(text)
    message.value = 'Copied!'
}

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        console.log('Fallback: Copying text command was ' + msg)
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
    }
    document.body.removeChild(textArea)
    emit('update:modelValue', false)
}
</script>

<style scoped>
.share-input i--click::after {
    animation: anim-effect-boris 0.3s forwards;
    background-color: red;
}
@keyframes anim-effect-boris {
    0% {
        transform: scale3d(0.3, 0.3, 1);
    }
    25%,
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: scale3d(1.2, 1.2, 1);
    }
}
</style>
